module.exports = __webpack_public_path__ + "img/7.3e6c6609.png";